import { WIDGET_VIEW_ARRAY } from "@smallstack/typesystem";
import { WidgetRegistryEntry } from "@smallstack/widget-core";

export const ArrayViewWidget: WidgetRegistryEntry = {
  name: WIDGET_VIEW_ARRAY,
  component: () => import("./array-view-widget.component").then((m) => m.ArrayViewWidgetComponent)
};
